import React from 'react'
import { TYPOLOGY_KEYS, TYPOLOGIES } from '../typologyData/typologies'

export default function TypologySelector({ value, onChange, compact = false }) {
  return (
    <div className="flex flex-wrap gap-2">
      {TYPOLOGY_KEYS.map((key) => {
        const t = TYPOLOGIES[key]
        const isSelected = value === key
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold transition-colors"
            style={{
              background: isSelected ? `${t.colour}15` : '#fff',
              borderColor: isSelected ? `${t.colour}66` : '#e2e8f0',
              color: isSelected ? t.colour : '#64748b',
            }}
          >
            <span
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ background: t.colour }}
            />
            {compact ? t.shortLabel : t.label}
          </button>
        )
      })}
    </div>
  )
}
